import { render, staticRenderFns } from "./lookPPT.vue?vue&type=template&id=01b95630&scoped=true&"
import script from "./lookPPT.vue?vue&type=script&lang=js&"
export * from "./lookPPT.vue?vue&type=script&lang=js&"
import style0 from "./lookPPT.vue?vue&type=style&index=0&id=01b95630&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b95630",
  null
  
)

export default component.exports